import { ActionType } from 'typesafe-actions';

import { PublishRulesActionsEnum } from 'PublishRulesPackage/MainModule/enums/publishRulesActionsEnum';
import { IKnmHistoryItemChanges } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryItemChanges';
import { IPublishRules } from 'APIPackage/PublishRulesModule/interfaces/IPublishRules';

import * as actions from '../actions/publishRulesActions';
import { IPublishRulesKnmScheduledFormRef } from '../interfaces/IPublishRulesKnmScheduledFormRef';
import { IPublishRulesKnmUnscheduledFormRef } from '../interfaces/IPublishRulesKnmUnscheduledFormRef';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { IPublishRulesKnmUnscheduledForm } from '../interfaces/IPublishRulesKnmUnscheduledForm';
import { IPublishRulesKnmScheduledForm } from '../interfaces/IPublishRulesKnmScheduledForm';
import { IPublishRulesPmForm } from '../interfaces/IPublishRulesPmForm';
import { IPublishRulesPmFormRef } from '../interfaces/IPublishRulesPmFormRef';
import { getTree } from '../common/getTree';
import { IPublishRulesErpScheduledForm } from '../interfaces/IPublishRulesErpScheduledForm';
import { IPublishRulesErpUnscheduledForm } from '../interfaces/IPublishRulesErpUnscheduledForm';
import { IPublishRulesErpUnscheduledFormRef } from '../interfaces/IPublishRulesErpUnscheduledFormRef';
import { PublishRulesApproveTypeEnum } from '../enums/publishRulesApproveTypeEnum';

export type PublishRulesAction = ActionType<typeof actions>;
export type MultipleHistoryChanges = { approveType: PublishRulesApproveTypeEnum; changes: IKnmHistoryItemChanges[] }[];

export type PublishRulesForm =
  | IPublishRulesKnmScheduledForm
  | IPublishRulesKnmUnscheduledForm
  | IPublishRulesPmForm
  | IPublishRulesErpScheduledForm
  | IPublishRulesErpUnscheduledForm;

export type PublishRulesFormRef =
  | IPublishRulesKnmUnscheduledFormRef
  | IPublishRulesKnmScheduledFormRef
  | IPublishRulesPmFormRef
  | IPublishRulesErpUnscheduledFormRef
  | IPublishRulesErpUnscheduledFormRef;

export interface IPublishRulesState {
  tree: IPublishRulesTreeItem[];
  activeTreeItem?: IPublishRulesTreeItem;
  nextActiveTreeItem?: IPublishRulesTreeItem;
  formRef?: PublishRulesFormRef;
  formData?: IPublishRules;
  historyChanges?: IKnmHistoryItemChanges[] | MultipleHistoryChanges;
  isNeedSaveAccept?: boolean;
}

const initialState: IPublishRulesState = {
  tree: getTree(),
  activeTreeItem: getTree()[0]?.children?.[0],
  formRef: undefined,
  formData: undefined,
  historyChanges: undefined,
  isNeedSaveAccept: false,
  nextActiveTreeItem: undefined,
};

export function publishRulesReducer(state: IPublishRulesState = initialState, action: PublishRulesAction) {
  switch (action.type) {
    case PublishRulesActionsEnum.PUBLISH_RULES_SET_TREE: {
      const { tree } = action.payload;
      const newState: IPublishRulesState = {
        ...state,
        tree,
      };

      return newState;
    }

    case PublishRulesActionsEnum.PUBLISH_RULES_SET_FORM_REF: {
      const { formRef } = action.payload;
      const newState: IPublishRulesState = {
        ...state,
        formRef,
      };

      return newState;
    }

    case PublishRulesActionsEnum.PUBLISH_RULES_SET_FORM_DATA: {
      const { formData } = action.payload;
      const newState: IPublishRulesState = {
        ...state,
        formData,
      };

      return newState;
    }

    case PublishRulesActionsEnum.PUBLISH_RULES_SET_HISTORY_CHANGES: {
      const { historyChanges } = action.payload;
      const newState: IPublishRulesState = {
        ...state,
        historyChanges,
      };

      return newState;
    }

    case PublishRulesActionsEnum.PUBLISH_RULES_SET_IS_NEED_SAVE_ACCEPT: {
      const { isNeedSaveAccept } = action.payload;
      const newState: IPublishRulesState = {
        ...state,
        isNeedSaveAccept,
      };

      return newState;
    }

    case PublishRulesActionsEnum.PUBLISH_RULES_SET_NEXT_ACTIVE_TREE_ITEM: {
      const { item } = action.payload;
      const newState: IPublishRulesState = {
        ...state,
        nextActiveTreeItem: item,
      };

      return newState;
    }

    case PublishRulesActionsEnum.PUBLISH_RULES_UPDATE_ACTIVE_TREE_ITEM: {
      const { item } = action.payload;
      const newState: IPublishRulesState = {
        ...state,
        activeTreeItem: item,
      };

      return newState;
    }

    default:
      return state;
  }
}
